import { cva } from "class-variance-authority";

// Touch: on a coarse pointer every button is at least 44x44. min-h/min-w (not h/w) so a
// caller's h-7 w-7 still sets the mouse size; opt out with "[@media(pointer:coarse)]:min-h-0
// [@media(pointer:coarse)]:min-w-0".
// The arbitrary media variant is emitted after sm:/lg:/xl:, so it wins over responsive heights.
// "transition" (not transition-all) so a size change never animates.
export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 [@media(pointer:coarse)]:min-h-11 [@media(pointer:coarse)]:min-w-11",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/85 shadow-sm",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        google: "bg-card border border-border text-foreground hover:bg-muted shadow-sm",
        whatsapp: "bg-[hsl(142,70%,45%)] text-white hover:bg-[hsl(142,70%,40%)] shadow-sm",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-12 rounded-lg px-8 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
